import React from 'react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1
  }
};

const Backgroundetails: React.FC = () => {
  return (
    <div className="mt-40 md:mt-40 px-4 md:px-8 bg-black ">
      <div className="max-w-2xl md:max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >

          {/* Main heading */}
             <motion.h2 
            className="text-lg font-bold mb-6 text-white"
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
          >
            Get to Know me
          </motion.h2>


          <motion.h1
            className="text-2xl font-bold leading-[2.3rem] text-left mb-12 md:text-5xl md:font-semibold md:leading-[3.5rem] md:max-w-5xl md:mb-12 md:text-left"
            variants={itemVariants}
          >
            I'm Manish Shrestha, a UI/UX Designer with frontend development skills. I craft clean, user-friendly digital experiences using Figma, React, and JavaScript. With a background in Computer Science and experience across web and mobile platforms, I focus on design that's simple, functional, and impactful.
          </motion.h1>

          {/* Button right-aligned */}
          <motion.div
            className="flex justify-end"
            variants={itemVariants}
          >
            <motion.a
              href="/work"
              whileHover={{ scale: 1.08, boxShadow: '0 4px 24px 0 rgba(255,255,255,0.08)' }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="group flex items-center gap-2 px-5 py-2 text-base font-medium border border-white/30 rounded-full hover:bg-white/40 transition-all duration-300 shadow-sm md:gap-4 md:px-6 md:py-3 md:text-lg"
            >
              View my work
              <span className="flex items-center justify-center w-8 h-8 border border-white rounded-full ml-2 group-hover:bg-white/10 transition-all duration-300">
                <span className="transition-transform duration-300 group-hover:translate-x-1">→ </span>
              </span>
            </motion.a>
          </motion.div>
        </motion.div>

        {/* Sight line separator */}
        <div className="border-t border-white/20 my-20"></div>

        <motion.div className="flex flex-col md:flex-row md:justify-between md:items-start mb-12">
          <h2 className="text-lg font-bold">Design. That. Connects.</h2>
          <motion.h4
            className="text-base font-normal leading-relaxed md:text-base md:leading-relaxed md:max-w-4xl text-white opacity-[60%] md:ml-auto"
            variants={itemVariants}
          >
            To me, design goes far beyond aesthetics it's a tool for problem-solving, connection, and meaningful impact. I approach every project with precision, ensuring that each pixel has purpose and every choice is grounded in intention.

            <br></br><br></br>My process is guided by data and insight, allowing the brief to define the creative direction—not fleeting trends. I focus on delivering thoughtful solutions that resonate deeply and offer lasting value, rather than producing design for design's sake.

            I'm passionate about crafting experiences that are not only visually compelling but also strategically driven. Whether it's shaping a brand, refining a product, or visualizing a bold idea, I strive to deliver work that is both effective and refined.

            <br></br><br></br> For me, design is the intersection of technology and culture. I thrive in collaborative environments, where complex challenges can be transformed into clear, purposeful solutions that push boundaries while meeting real-world needs.
          </motion.h4>
        </motion.div>

        <motion.div
          className="flex justify-end md:pl-80"
          variants={itemVariants}
        >
          <motion.a
            href="https://www.linkedin.com/in/manish-shrestha-3b03291b4/"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center text-white text-sm border-b border-white/60 pb-1 hover:border-white transition-all duration-300"
            whileHover={{
              scale: 1.08,
              x: 5
            }}
            transition={{
              type: "spring",
              stiffness: 400,
              damping: 10
            }}
          >
            <svg
              className="w-4 h-4 mr-2 group-hover:scale-160 transition-transform duration-400"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
            </svg>
            Connect on Linkedin
            <motion.span
              className="ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              initial={{ x: -10 }}
              animate={{ x: 0 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              →
            </motion.span>
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
};

export default Backgroundetails;